import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";
import {NativeSelect} from "@mui/material";
import {getTaskDefinition, saveTask} from "../common/api/TasksApi";

export default function ManageTaskDefinition({taskDefinition, handleSave, show, handleClose, callback}) {

  const [context, setContext] = useContext(AppContext);
  const [formInvalid, setFormInvalid] = useState(false);
  const [saving, setSaving] = useState(false);
  const [isNew, setIsNew] = useState(!taskDefinition?.guid);

  const [inventoryEventTypes, setInventoryEventTypes] = useState([]);

  const [taskTypes, setTaskTypes] = useState();

  useEffect(() => {
    getTaskDefinition().then((resp) => {
      setTaskTypes(resp);
    });
  }, [])

  const {register, handleSubmit, setValue, getValues, control} = useForm({
    values: handleDefaultValues(taskDefinition)
  });

  const handleSaveFn = (data) => {
    setSaving(true);
    saveTask(data).then(r => {
      setSaving(false);
      handleSave();
    })
  }
  const [help, setHelp] = useState({
    taskName: {value: taskDefinition?.taskName}
  });

  return (
    <Modal onHide={handleClose} size={'md'} show={show}>
      <form onSubmit={handleSubmit(handleSaveFn)} id={'eventLocationForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{isNew ? 'Create New' : 'Manage'} Automated Task</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row style={{
                  marginBottom: '20px'
                }}>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <MDInput
                        type="text"
                        InputLabelProps={{shrink: true}}
                        placeholder={"Enter Task Name"}
                        {...register('taskName', {
                          onChange: (e) => {
                          }
                        })}
                        autoComplete="off" required
                        className="form-control" id="taskName"
                        label="Task Name"/>
                    </div>
                  </Col>
                </Row>
                <Row style={{
                  marginBottom: '20px'
                }}>
                  <Col className={'col '} md={12} sm={12}>
                    <div className="form-group native-margin-fix">
                      <label htmlFor="eventType" className={"native-label"}>Task Event *</label>
                      {taskTypes?.taskEventTypes?.length > 0 && <NativeSelect
                        required
                        variant="outlined"
                        id={'eventType'} name={'eventType'}
                        className={'form-control'}
                        {...register('taskEventType.id', {
                          valueAsNumber: true,
                          required: true,
                          min: 1,
                          onChange: (e) => {
                          }
                        })} >
                        <option value={-1}>
                          Select Task Type
                        </option>

                        {taskTypes?.taskEventTypes.map((c) =>
                          <option value={c.id} key={c.id}>
                            {c.name}
                          </option>)
                        }

                      </NativeSelect>}
                    </div>
                  </Col>
                </Row>
                <Row style={{
                  marginBottom: '20px'
                }}>
                  <Col className={'col '} md={12} sm={12}>
                    <div className="form-group native-margin-fix">
                      <label htmlFor="eventType" className={"native-label"}>Event Type *</label>
                      {taskTypes?.eventTypes?.length > 0 && <NativeSelect
                        required
                        variant="outlined"
                        id={'eventType'} name={'eventType'}
                        className={'form-control'}
                        {...register('eventType.id', {
                          valueAsNumber: true,
                          required: true,
                          min: 1,
                          onChange: (e) => {
                          }
                        })} >
                        <option value={-1}>
                          Select Event Type
                        </option>

                        {taskTypes?.eventTypes.map((c) =>
                          <option value={c.id} key={c.id}>
                            {c.name}
                          </option>)
                        }

                      </NativeSelect>}
                    </div>
                  </Col>
                </Row>

                <Row style={{
                  marginBottom: '20px'
                }}>
                  <Col className={'col '} md={12} sm={12}>
                    <div className="form-group native-margin-fix">
                      <label htmlFor="eventType" className={"native-label"}>Choose Action *</label>
                      {taskTypes?.taskTypes?.length > 0 && <NativeSelect
                        required
                        defaultValue={-1}
                        variant="outlined"
                        id={'eventType'} name={'eventType'}
                        className={'form-control'}
                        {...register('taskType.id', {
                          valueAsNumber: true,
                          required: true,
                          min: 1,
                          onChange: (e) => {
                          }
                        })} >
                        <option value={-1}>
                          Select Action
                        </option>

                        {taskTypes?.taskTypes.map((c) =>
                          <option value={c.id} key={c.id}>
                            {c.name}
                          </option>)
                        }

                      </NativeSelect>}
                    </div>
                  </Col>
                </Row>
                <Row style={{
                  marginBottom: '20px'
                }}>
                  <Col className={'col '} md={12} sm={12}>
                    <div className="form-group native-margin-fix">
                      <label htmlFor="eventType" className={"native-label"}>Communication Template *</label>
                      {taskTypes?.communicationTemplates?.length > 0 && <NativeSelect
                        required
                        variant="outlined"
                        id={'eventType'} name={'communicationTemplate'}
                        className={'form-control'}
                        {...register('communicationTemplate.id', {
                          valueAsNumber: true,
                          required: true,
                          min: 1,
                          onChange: (e) => {
                          }
                        })} >
                        <option value={-1}>
                          Select Template
                        </option>

                        {taskTypes?.communicationTemplates.map((c) =>
                          <option value={c.id} key={c.id}>
                            {c.templateName}
                          </option>)
                        }

                      </NativeSelect>}
                    </div>
                  </Col>
                </Row>

                <Row style={{
                  marginBottom: '20px'
                }}>
                  <Col className={'col'} sm={4} xs={12}>
                    <div className="form-group">

                      <MDInput
                        type="number"
                        required
                        {...register('criteria', {
                          onChange: (e) => {
                          }
                        })}
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        placeholder={"Time Value"}
                        className="form-control" id="criteria"
                        label="Time Value"/>

                    </div>
                  </Col>
                  <Col className={'col '} md={8} sm={12}>
                    <div className="form-group native-margin-fix">
                      <label htmlFor="eventType" className={"native-label"}>Choose Time Period *</label>
                      {taskTypes?.timeUnitTypes?.length > 0 && <NativeSelect
                        required
                        variant="outlined"
                        id={'eventType'} name={'eventType'}
                        className={'form-control'}
                        {...register('timeUnitType.id', {
                          valueAsNumber: true,
                          required: true,
                          min: 1,
                          onChange: (e) => {
                          }
                        })} >
                        <option value={-1}>
                          Select Time Type
                        </option>

                        {taskTypes?.timeUnitTypes.map((c) =>
                          <option value={c.id} key={c.id}>
                            {c.name}
                          </option>)
                        }

                      </NativeSelect>}
                    </div>
                  </Col>
                </Row>

              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={formInvalid || saving}>
            {saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}